import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import type { Issue, IssuesMeta } from "@/app/issues/_types/issues.types";

const OVERVIEW_ISSUES_LIMIT = 4;

export const useOverviewUnreadIssuesQuery = () => {
  return useQuery({
    queryKey: ["overview", "issues-unread", OVERVIEW_ISSUES_LIMIT],
    queryFn: async () => {
      const response = await axiosInstance.get<ApiResponse<Issue[], IssuesMeta>>(
        "/v2/issues",
        {
          params: {
            type: "all",
            period: "all",
            status: "unread",
            page: 1,
            limit: OVERVIEW_ISSUES_LIMIT,
          },
        }
      );

      return {
        items: response.data.data ?? [],
        meta: response.data.meta,
      };
    },
  });
};
